import T from 'i18n-react';

import texts from 'Components/texts.json';
import { useCurrentFilter } from 'Stores/SavedFiltersStore/SavedFiltersStore';

import { ActiveSavedSearch } from './ActiveSavedSearch';
import { SavedSearchOptionsToggle } from './SavedSearchOptionsToggle';

T.setTexts(texts);

interface SavedSearchPillProps {
	onClick?: () => void;
	onMouseEnter?: () => void;
}

export const SavedSearchPill: React.FC<SavedSearchPillProps> = ({ onClick, onMouseEnter }) => {
	const currentFilter = useCurrentFilter();

	return (
		<>
			{currentFilter ? (
				<ActiveSavedSearch onClick={onClick} onMouseEnter={onMouseEnter} />
			) : (
				<SavedSearchOptionsToggle onClick={onClick} onMouseEnter={onMouseEnter} />
			)}
		</>
	);
};
